import { prepareTagList } from '@/utils/basics';
import { checkAuthTokens } from '@/utils/sessions';
import { getData } from '@/utils/api';

export const getTag = async (tag) => {
    const { jwttoken } = checkAuthTokens();
    const response = await getData({auth:jwttoken, endpoint: `/tags/${tag}`});

    if (response.error) {
      return tag;
    }

    return response;
  };

  export const  getTags = async (tags, full = false) => {
    let newTags = await Promise.all(
      tags.map(getTag)
    );

    newTags = newTags.map(({content}) => content);

    if (full) {
      return prepareTagList(newTags);
    }
    return newTags.map(tag => tag?.title || tag);
  };